import Cookies from "js-cookie";

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

export const clearClientAuthSession = () => {
  Cookies.remove("auth");
  localStorage.removeItem("token");
};

export const clearAuthSession = async () => {
  clearClientAuthSession();

  try {
    await fetch(`${apiBaseUrl}/users/signout`, {
      method: "GET",
      credentials: "include",
    });
  } catch (_error) {
    // Backend may be unavailable during local development.
  }
};

export const hasStoredAuthSession = () =>
  Boolean(Cookies.get("auth") || localStorage.getItem("token"));
